import { LoadingSpinner } from './LoadingSpinner';

/**
 * PageLoading - Fallback de Suspense para lazy loading de páginas.
 * Usa exclusivamente variáveis CSS do design system.
 */
export function PageLoading() {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{
        minHeight: '60vh',
        fontFamily: 'var(--font-family-inter)',
      }}
    >
      <div
        className="flex flex-col items-center gap-4 p-8"
        style={{
          backgroundColor: 'var(--card)',
          borderRadius: 'var(--radius-card)',
          border: '1px solid var(--border)',
          boxShadow: 'var(--elevation-sm)',
        }}
      >
        <LoadingSpinner size="lg" />
        <div className="text-center">
          <p
            style={{
              fontWeight: 'var(--font-weight-semibold)',
              fontSize: 'var(--text-base)',
              color: 'var(--foreground)',
              marginBottom: '4px',
            }}
          >
            Carregando...
          </p>
          <p
            style={{
              fontSize: 'var(--text-sm)',
              color: 'var(--muted-foreground)',
            }}
          >
            Preparando a pagina para voce
          </p>
        </div>
      </div>
    </div>
  );
}
